<template>
   
    <div id="af3-shortcodes-floor-plan-page-main-component">

        <div class="af3-shortcodes-floor-plan-page-main-component-tabs" v-if="options.floor_plans_loop_show_fees || options.floor_plans_loop_show_site_map">
            <button :class="activeTab === 'floor-plans' ? 'active' : ''" @click="handleTabChange('floor-plans')">Floor Plans</button>
            <button v-if="options.floor_plans_loop_show_site_map && options.floor_plans_loop_map_code" :class="activeTab === 'site-map' ? 'active' : ''" @click="handleTabChange('site-map')">Site Map</button>
            <button v-if="options.floor_plans_loop_show_fees" :class="activeTab === 'fees' ? 'active' : ''" @click="handleTabChange('fees')">Fees</button>
        </div>

        <div class="af3-shortcodes-floor-plan-page-main-component-tab-content">
            <floor-plan-loop-component v-if="activeTab === 'floor-plans'" :floor_plans="floor_plans" :options="options" :resources_url="resources_url" />
            <site-map-component v-if="activeTab === 'site-map'" :options="options" :map_code="options.floor_plans_loop_map_code" :resources_url="resources_url" />
            <fees-component v-if="activeTab === 'fees'" :options="options" :resources_url="resources_url" :floor_plans="floor_plans" :property_fees="property_fees" />
        </div>

        
    </div>
    
</template>
  
<script>

import { defineComponent, ref, watch, onMounted, reactive  } from 'vue';
import FloorPlanLoopComponent from './FloorPlanLoopComponent.vue';
import SiteMapComponent from './SiteMapComponent.vue';
import FeesComponent from './FeesComponent.vue';

export default defineComponent({
    components: { FloorPlanLoopComponent, SiteMapComponent, FeesComponent },
   
    props: {
        options: {
            type: Object,
            required: true
        },
        floor_plans: {
            type: Array,
            required: true
        },
        resources_url: {
            type: String,
            required: true
        },
        property_fees: {
            type: Array,
            required: true
        }
    },

    setup(props) {

        const activeTab = ref('floor-plans');

        const handleTabChange = (tab) => {
            activeTab.value = tab;
        }

         
    return {
        activeTab,
        handleTabChange
    };
  },


  
  
});
</script>